import { Component, OnInit } from '@angular/core';
import { SectoresOrganizacionalesService } from 'src/app/services/sectores-organizacionales.service';
import { element } from 'protractor';

@Component({
  selector: 'app-sectores-organizacionales',
  templateUrl: './sectores-organizacionales.component.html',
  styleUrls: ['./sectores-organizacionales.component.css']
})
export class SectoresOrganizacionalesComponent implements OnInit {

  sector: boolean;
  ocupacion: boolean;
  nivel: boolean;
  estandar: boolean;
  detalle :boolean;

  title: string;
  lastTitle:string;
  titleSt: string;

  padre: number;
  hijo : number;

  cadigoEC = "";
  titles : string[] = [];
  ids : number[] = [];

  constructor(private service: SectoresOrganizacionalesService) {
    this.sector = true;
    this.ocupacion = false;
    this.nivel = false;
    this.estandar = false;
    this.detalle = false;
    this.title = 'Estándares de competencia por ocupación';
  }

  ngOnInit(): void {

  }

  itemSelected(event) {
    if (this.sector && !this.ocupacion && !this.nivel && !this.estandar) {
      this.sector = false;
      this.ocupacion = true;
      this.nivel = false;
      this.estandar = false;
      this.detalle = false;
      this.ids[0] = event.element.id;
      this.titles[0] = event.element.descripcion;
    } else if (this.ocupacion && !this.nivel && !this.sector && !this.estandar) {
      this.sector = false;
      this.ocupacion = false;
      this.nivel = true;
      this.estandar = false;
      this.detalle = false;
      this.titles[1] = event.element.descripcion;
      this.ids[1] = event.element.id;
    } else if (this.nivel && !this.ocupacion && !this.sector && !this.estandar) {
      this.sector = false;
      this.ocupacion = false;
      this.nivel = false;
      this.estandar = false;
      this.detalle = true;
      this.cadigoEC = event.element.cdEstandarCompetencia;
      this.titleSt = event.element.nbTituloEc;
      this.titles[2] = event.element.descripcion;
      this.ids[2] = event.element.id;
    } 
    this.title = event.element.descripcion;
    
    this.hijo = event.element.id;
    this.padre = event.padre;
    this.lastTitle = event.lastTitle;
  }

  detalleByEst(event) {
    this.titleSt = "";
    this.cadigoEC = "";
    if (!this.nivel && !this.ocupacion && !this.sector && this.estandar && !this.detalle) {
      this.sector = false;
      this.ocupacion = false;
      this.nivel = false;
      this.estandar = false;
      this.detalle = true
      this.cadigoEC = event.element.cdEstandarCompetencia;
    }
    this.padre = event.padre;
    this.lastTitle = event.lastTitle;
    this.titleSt = event.element.nbTituloEc
  }


  async onBack(event) {    
    if (event.sector) {
      this.title = 'Estándares de competencia por ocupación';
    } else if (event.nivel ) {      
      this.title = this.lastTitle;
      this.hijo = this.padre;
    } else if (event.ocupacion) {               
      this.title = this.titles[0];
      this.hijo = this.ids[0];
    } else {
      this.title = this.lastTitle;
      this.hijo = this.padre;
    }
    this.sector = event.sector;
    this.ocupacion = event.ocupacion;
    this.nivel = event.nivel;
    this.estandar = event.estandar;
    this.detalle = event.detalle;
  }

}
